import { render } from "./Polls.vue?vue&type=template&id=4b2388c5&scoped=true"
import script from "./Polls.vue?vue&type=script&lang=js"
export * from "./Polls.vue?vue&type=script&lang=js"

import "./Polls.vue?vue&type=style&index=0&id=4b2388c5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2388c5"]])

export default __exports__